import WebsterAccessibility from '../helpers/accessbility';
import { scrollPageTo } from './anchor-scroll';

const acc = document.querySelectorAll('[data-js=accordion]');

for (let i = acc.length - 1; i >= 0; i -= 1) {
	acc[i].addEventListener('click', (event) => {
		if (!event.target.matches('.acc-item')) return;
		event.preventDefault();

		event.target.classList.toggle('active-accordion');
	});
	acc[i].addEventListener('keyup', (event) => {
		if (!event.target.matches('.acc-item')) return;
		if(event.key === 'Enter') {
			event.preventDefault();
			event.target.classList.toggle('active-accordion');
		}
	});
}

/** ----//
------------------------------------------🧿--🧿

Adding Nested Accordion

------------------------------------------🧿--🧿
//----*/
const setToggleChanges = (type, accordion, button) => {
	try {
		const expandButton = button;

		if (expandButton) {
			if (expandButton.dataset.js !== 'expand-group') {
				const expandButtonText = {
					add: expandButton.dataset.nestedGroupName ? `Collapse All ${expandButton.dataset.nestedGroupName} FAQs` : 'Collapse All',
					remove: expandButton.dataset.nestedGroupName ? `Expand All ${expandButton.dataset.nestedGroupName} FAQs` : 'Expand All',
				};
				expandButton.innerHTML = expandButtonText[type];
			}
		}
		if (type === 'remove') {
			if (accordion) {
				accordion.classList.remove('active-accordion');
			}
			if (expandButton) {
				expandButton.classList.remove('expanded');
			}
		} else if (type === 'add') {
			if (accordion) {
				accordion.classList.add('active-accordion');
			}
			if (expandButton) {
				expandButton.classList.add('expanded');
			}
		}
	} catch (error) {
		console.error(error);
	}
};
const toggleAccordions = (
	accordions,
	isexpanded,
	expandbutton = false,
	groupparent = false,
	toggleall = false,
) => {
	try {
		/* ----//  Toggle Accordion Children  //----*/
		const expandAllBtn = expandbutton;
		const toggeleAllMode = toggleall;
		if (accordions instanceof NodeList || accordions instanceof Node) {
			if (accordions instanceof NodeList) {
				accordions.forEach((accordion) => {
					if (!isexpanded) {
						setToggleChanges('remove', accordion, expandAllBtn);
						if (toggeleAllMode) {
							setToggleChanges(
								'remove',
								'',
								accordion.querySelector('[data-js="expand-group"]'),
							);
						}
					} else {
						setToggleChanges('add', accordion, expandAllBtn);
						if (toggeleAllMode) {
							setToggleChanges(
								'add',
								'',
								accordion.querySelector('[data-js="expand-group"]'),
							);
						}
					}
				});
			} else if (accordions instanceof Node) {
				if (!isexpanded) {
					setToggleChanges('remove', accordions, expandAllBtn);
				} else {
					setToggleChanges('add', accordions, expandAllBtn);
				}
			}
		}
		const groupParent = groupparent;
		if (groupParent) {
			if (isexpanded) {
				if (!groupParent.classList.contains('expanded')) {
					groupParent.classList.add('expanded');
				}
			} else {
				groupParent.classList.remove('expanded');
			}
		}
	} catch (error) {
		console.log(error);
	}
};
/* ----//  Expand all QUESTIONS within a group  //----*/
const expandAllQuestions = () => {
	const expandAllQuestionsBtns = document.querySelectorAll(
		'[data-js="expand-questions"]',
	);
	expandAllQuestionsBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			// e.preventDefault();
			const expandAllBtn = e.target;
			const parent = expandAllBtn.closest('.nested-faqs');
			const accordions = parent.querySelectorAll('[data-js="accordion"]');
			const activeAccordions = parent.querySelectorAll(
				'.acc-item.active-accordion',
			);
			const isAllExpanded = accordions.length !== activeAccordions.length;
			/* ----//  Toggle Accordion Children  //----*/
			toggleAccordions(accordions, isAllExpanded, expandAllBtn, parent);
		});
	});
};
/* ----//  Expand an individual group  //----*/
const expandGroup = () => {
	const getExpandGroupBtns = document.querySelectorAll(
		'[data-js="expand-group"]',
	);
	getExpandGroupBtns.forEach((btn) => {
		btn.addEventListener('click', (event) => {
			const expandGroupBtn = event.target.closest('button');
			const expandGroupBtnCollapsed = !expandGroupBtn.classList.contains('expanded');
			const expandAllParent = expandGroupBtn.closest('.nested-faqs');
			/* ----//  Expand or Collapse Groups  //----*/
			// const accordionGroups = document.querySelectorAll('.nested-faqs');
			toggleAccordions(
				expandAllParent,
				expandGroupBtnCollapsed,
				expandGroupBtn,
				'',
			);

			/* ----//  Manage Expand All  //----*/
			const getOpenGroups = document.querySelectorAll('.nested-faqs.active-accordion');
			const getAccordions = document.querySelectorAll('.nested-faqs');
			const expandAllElement = document.querySelector('.accordion-heading.nested-accordion');
			const expandAllBtn = expandAllElement.querySelector('button');
			// window.openAccordionGroups.count = getOpenGroups.length;
			if (getOpenGroups.length === 0) {
				toggleAccordions(
					getAccordions,
					false,
					'',
					'',
					true,
				);
				expandAllElement.classList.remove('expanded');
				expandAllBtn.innerHTML = 'Expand All FAQ Topics';
				expandAllBtn.classList.remove('expanded');
				window.openAccordionGroups.openAccordions = {
					expandAll: false,
					eventData: event,
				};
			} else if (getOpenGroups.length === getAccordions.length) {
				toggleAccordions(
					getAccordions,
					true,
					'',
					'',
					true,
				);
				expandAllElement.classList.add('expanded');
				expandAllBtn.innerHTML = 'Collapse All FAQ Topics';
				expandAllBtn.classList.add('expanded');
				window.openAccordionGroups.openAccordions = {
					expandAll: true,
					eventData: event,
				};
			}
		});
	});
};
/* ----//  Expand ALL groups. Questions remain closed.  //----*/
const expandAllGroups = () => {
	const getExpandAllGroupsBtn = document.querySelectorAll(
		'.nested-accordion button',
	);
	getExpandAllGroupsBtn.forEach((btn) => {
		btn.addEventListener('click', (event) => {
			const expandAllBtn = event.target;
			const expandAllBtnExpanded = !expandAllBtn.classList.contains('expanded');
			const expandAllParent = expandAllBtn.closest('.nested-accordion');
			const expandAll = expandAllBtnExpanded;
			/* ----//  Expand or Collapse Groups  //----*/
			const accordionGroups = document.querySelectorAll('.nested-faqs');
			toggleAccordions(accordionGroups, expandAll, '', '', true);
			/* ----//  Manage Expand All  //----*/
			if (expandAllParent) {
				if (expandAll) {
					if (!expandAllParent.classList.contains('expanded')) {
						expandAllParent.classList.add('expanded');
						expandAllBtn.innerHTML = 'Collapse All FAQ Topics';
						expandAllBtn.classList.add('expanded');
					}
				} else if (expandAllParent.classList.contains('expanded')) {
					expandAllParent.classList.remove('expanded');
					expandAllBtn.innerHTML = 'Expand All FAQ Topics';
					expandAllBtn.classList.remove('expanded');
				}
			}
		});
	});
};
/* ----//  Set Top Positioning for Sticky Headings  //----*/
const setPositionGroupHeading = () => {
  const siteheaderHeight = window.siteHeaderHeight;
  if(!siteheaderHeight) return;
  /*----//  Set Anchor Top Value for Accordion Group Heading  //----*/
  const faqGroupHeadings = document.querySelectorAll('.nested-faqs--group-header');
  if (faqGroupHeadings.length > 0) {
    faqGroupHeadings.forEach((anchor) => {
      anchor.style.top = `${siteheaderHeight}px`;
    });
  }
};

const setUpAnchorScrolling = (anchorSections, type) => {
  /*----//  Handle Expand FAQ Group or Question based on Anchor Link  //----*/
  if(window.location.hash) {
    const getAnchorName = window.location.hash.substring(1);
    const getAnchorElement = document.getElementById(getAnchorName) || document.querySelector(`a[name="${getAnchorName}"]`);
    const anchoredSection = getAnchorElement.closest('.section--faqaccordion.nested-faqs');
    const anchoredQuestion = getAnchorElement.closest(".acc-item");
    if(!anchoredSection && !anchoredQuestion) return;
    if(anchoredSection) {
      //Handle Expand Group
      const getExpandBtn = anchoredSection.querySelector('[data-js="expand-group"]');
      if(!getExpandBtn) return;
      toggleAccordions(anchoredSection, true, getExpandBtn, '');
      if(anchoredQuestion){
        setToggleChanges('add', anchoredQuestion, getExpandBtn);
      }
    }else if(anchoredQuestion){
      //Handle Expand Question
      const anchoredSection = anchoredQuestion.closest('.section--faqaccordion');
      const getExpandBtn = anchoredSection.querySelector('[data-js="expand-questions"]');
      setToggleChanges('add', anchoredQuestion, getExpandBtn);
    }
  }
  if(anchorSections.length === 0) return;
  if(type === "groups") {
    anchorSections.forEach((anchoredSection) => {
      const getAnchorElement = anchoredSection.querySelector('.section-anchor');
      if (!getAnchorElement) return;
      const anchorName = getAnchorElement.getAttribute('name');
      if (anchorName) {
        const getExpandBtn = anchoredSection.querySelector('[data-js="expand-group"]');
        if(!getExpandBtn) return;
        const getLinksFromName = document.querySelectorAll(`a[href*="#${anchorName}"]`);
        if (getLinksFromName.length > 0) {
          getLinksFromName.forEach((link) => {
            link.addEventListener('click', (event) => {
              event.preventDefault();
              toggleAccordions(anchoredSection, true, getExpandBtn, '');
              scrollPageTo(anchorName);
            });
          });
        }
      }
    });
  }
  if(type === "question"){
    anchorSections.forEach((anchoredSection) => {
      const getAnchorElement = anchoredSection.closest('.acc-item');
      const anchorName = anchoredSection.getAttribute('id') ?? anchoredSection.getAttribute('name');
      console.log("wpro_debug__anchorName__object")
      console.log({wpro_debug__anchorName__object:anchorName})
      if (anchorName) {
        const getAnchoredSection = getAnchorElement.closest(".section--faqaccordion");
        const getExpandBtn = getAnchoredSection.querySelector('[data-js="expand-questions"]');
        const getLinksFromName = document.querySelectorAll(`a[href*="#${anchorName}"]`);
        if (getLinksFromName.length > 0) {
          getLinksFromName.forEach((link) => {
            link.addEventListener('click', (event) => {
              event.preventDefault();
              toggleAccordions(getAnchoredSection, true, getExpandBtn, '');
              setToggleChanges('add', getAnchorElement, getExpandBtn);
              scrollPageTo(anchorName);
            });
          });
        }
      }
    })
  }
};

document.addEventListener('DOMContentLoaded', () => {
	const hasAccordion = document.querySelector('.section--faqaccordion');
	if (!hasAccordion) return;
	/* ----//  FAQ Anchor Behavior  //----*/
  setPositionGroupHeading();
  //Check if FAQ Accordion has Anchor Link Set. This solution will only work on FAQ groups to expand when clicked on and not individual FAQ questions.
	const getFaqAnchors = document.querySelectorAll('.section--faqaccordion.section--has-anchor');
	if (getFaqAnchors.length > 0) {
		/* ----//  Set 'Top' position of heading to not cover the content  //----*/
		setUpAnchorScrolling(getFaqAnchors, "groups");
	}
  // Individual FAQ Question anchor link behavior.
  const getFaqQuestionAnchors = document.querySelectorAll('.section--faqaccordion .acc-item a[id], .section--faqaccordion .acc-item a[name]');
  if(getFaqQuestionAnchors.length > 0) {
    setUpAnchorScrolling(getFaqQuestionAnchors, "question");
  }

	expandAllQuestions();
	expandGroup();
	expandAllGroups();
	/* ----//  Add Accordion Accessibility  //----*/
	const siteAccessibility = new WebsterAccessibility();
	siteAccessibility.init();
});
